import { en } from './en';
//import { sv } from './sv';

export const translations = {
  en,
};
